<template>
    <div>
        <div class="row mb-3">
            <div class="col-12">
                <label class="radio-btn">
                    <span class="position-relative d-inline-flex align-items-center">
                        All&nbsp;
                        <input type="radio" :name="name + '-mode'" value="all" v-model="mode" @change="onModeChange">
                        <span class="checked"></span>
                    </span>
                </label>&nbsp;/&nbsp;
                <label class="radio-btn">
                    <span class="position-relative d-inline-flex align-items-center">
                        None&nbsp;
                        <input type="radio" :name="name + '-mode'" value="none" v-model="mode" @change="onModeChange">
                        <span class="checked"></span>
                    </span>
                </label>
            </div>
        </div>
        <div class="row" v-if="permissions.length">
            <input v-if="favoriteParamName" type="hidden" :name="favoriteParamName" v-model="favorite">
            <div class="col-lg-3 col-md-6 col-sm-12 mt-2" v-for="permission in permissions">
                <input type="hidden" :name="`${name + (replace ? '_mock' : '')}[${permission.id}]`" value="0">

                <span class="default-set-icon" v-if="favoriteParamName" v-show="showFavorite(permission.id)">
                    <app-icon v-show="!isFavorite(permission.id)" name="star-outline" @click="updateFavorite(permission.id)"></app-icon>
                    <app-icon v-show="isFavorite(permission.id)" name="star" classes="active none yellow" @click="updateFavorite(0)"></app-icon>
                </span>

                <app-checkbox
                    :label="permission.name"
                    :name="`${name + (replace ? '_mock' : '')}[${permission.id}]`"
                    :id="name + permission.id"
                    v-model="permission.checked"
                    @input="onChange(permission.id)"
                    value="1"
                    :init-state="(permission.checked ? true : false)"
                />
            </div>
        </div>
        <template v-if="replace">
            <input
                v-for="perm in clickedPermissions"
                type="hidden"
                :name="`${name}[${perm.id}]`"
                :value="+perm.checked"
                :key="perm.id"
            >
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            permissionList: Array,
            name: String,
            replace: {
                type: Boolean,
                default: false
            },
            role: {
                type: String
            },
            favoriteParamName: {
                type: String,
                default: ''
            },
            favoriteId: {
                type: Number,
                default: 0
            },
            old: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                permissions: this.permissionList,
                clickedPermissions: [],
                mode: '',
                favorite: 0
            }
        },
        methods: {
            checkPermissionsMode() {
                let checkedCount = 0;
                this.permissions.forEach(item => {
                    if (item.checked) {
                        checkedCount++;
                    }
                });

                setTimeout(
                    () => {
                        if (this.permissions.length === 0 || checkedCount === 0) {
                            this.mode = 'none';
                        } else if (this.permissions.length === checkedCount && checkedCount > 0) {
                            this.mode = 'all';
                        } else {
                            this.mode = '';
                        }
                    }, 1
                );
            },
            onModeChange() {
                const checked = this.mode === 'all';

                this.permissions.forEach(item => {
                    item.checked = checked;
                    this.onChange(item.id);
                });
            },
            onChange(id) {
                const permission = this.clickedPermissions.find(item => item.id === id);
                const checked = this.permissions.find(item => item.id === id).checked;
                if (permission) {
                    permission.checked = checked;
                } else {
                    this.clickedPermissions.push({
                        id: id,
                        checked: checked
                    });
                }
                this.checkPermissionsMode();
            },
            updateFavorite(id) {
                this.$globalEvents.$emit('roleUpdateFavorite', id);
            },
            isFavorite(id) {
                return id === this.favorite;
            },
            showFavorite(id) {
                return this.permissions.find(item => item.id == id).checked;
            }
        },
        mounted() {
            setTimeout(
                () => {
                    if (Object.keys(this.old).length > 0) {
                        this.permissions.forEach((item, idx) => {
                            if (this.old[item.id] == 1) {
                                this.permissions[idx].checked = true;
                                item.checked = true;
                                this.onChange(item.id);
                            } else {
                                this.permissions[idx].checked = false;
                                item.checked = false;
                                this.onChange(item.id);
                            }
                        });
                    } else {
                        this.permissions.forEach(item => {
                            if (item.checked) {
                                this.onChange(item.id);
                            }
                        });
                    }
                }, 1
            );


            this.checkPermissionsMode();
            this.favorite = this.favoriteId;

            this.$globalEvents.$on('roleUpdateFavorite', (id) => {
                this.favorite = id;
            });
        },
        watch: {
            permissionList(value) {
                this.permissions = value;
                this.checkPermissionsMode();
            },
            role(value) {
                this.clickedPermissions = [];
            }
        }
    };
</script>
<style lang="scss" scoped>
    label {
        margin-bottom: 0;
    }
    .default-set-icon {
        cursor: pointer;
        width: 15px;
        display: inline-block;
    }
    .checkbox-wrapper {
        max-width: calc(100% - 20px);
    }
    ion-icon.none.yellow{
        color: #ffc107
    }
</style>
